import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { GOOGLE_RECAPTCHA_SITE_KEY } from "../Globals";

function Captcha({ setCaptchaValue }) {
  return (
    <ReCAPTCHA
      sitekey={GOOGLE_RECAPTCHA_SITE_KEY}
      onChange={(value) => setCaptchaValue(value)}
      style={{ marginTop: "1em" }}
      hl="en"
    />
  );
}

export default Captcha;
